<template lang="pug">
	.reading-rules-editor.flex-col.space-large
		.flex-col
			.font-small.upper.grey {{$tCaption('Text')}}
			.font-large {{text}}
		.flex-row.space
			.flex-col.flex-1
				.font-small.upper.grey {{$tCaption('Reading rule')}}
				DxSelectBox(:value.sync="innerValue['interpret-as']", :data-source="readingRules", display-expr="text", value-expr="id", :dropDownOptions="{ width: '220px' }", :showClearButton="true")
			.flex-col.flex-1(v-if="selectedRule && selectedRule.formats")
				.font-small.upper.grey {{$tCaption('Format')}}
				DxSelectBox(:value.sync="innerValue.format", :data-source="selectedRule.formats", display-expr="text", value-expr="id", :dropDownOptions="{ width: '120px' }")
</template>

<script>
	import _ from 'lodash';
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import Loader from 'app-core/Loader.vue';
	import DxSelectBox from 'devextreme-vue/select-box';

	export default {
		translationCategory: 'insertion.SSMLReadingRulesEditor',
		name: 'reading-rules-editor',
		components: {
			DxButton, DxTextBox, DxSelectBox,
			Loader
		},
		model: {
			prop: 'value',
			event: 'change '
		},
		props: ['text', 'value'],
		data() {
			return {
				innerValue: _.merge({
					'interpret-as': null,
					format: null
				}, this.value),
				readingRules: [
					{ id: 'address' },
					{ id: 'alphanumeric' },
					{ id: 'cardinal', formats: [',', '.'] },
					{ id: 'currency' },
					{ id: 'date', formats: ['dmy', 'mdy', 'ymd', 'ydm', 'ym', 'my', 'md', 'dm', 'd', 'm', 'y'] },
					{ id: 'duration', formats: ['hms', 'hm', 'ms'] },
					{ id: 'email' },
					{ id: 'math' },
					{ id: 'message' },
					{ id: 'ordinal' },
					{ id: 'name' },
					{ id: 'spell' },
					{ id: 'telephone' },
					{ id: 'time' },
					{ id: 'URL' },
				].map(f => ({
					id: f.id,
					text: `${f.id.substr(0,1).toUpperCase()}${f.id.substr(1,999)}`,
					formats: f.formats && f.formats.map(fm => ({ id: fm, text: fm }))
				}))
			};
		},
		computed: {
			selectedRule() {
				return _.find(this.readingRules, (v) => v.id === this.innerValue['interpret-as']);
			}
		},
		watch: {
			innerValue: {
				handler() {
					this.$emit('change', this.innerValue);
				},
				deep: true
			},
			selectedRule(v) {
				this.innerValue.format = null;
				if (v && v.formats) {
					this.innerValue.format = v.formats[0].id;
				}
			}
		},
		mounted() {
			if (__DEBUG__)
				window.readingRulesEditor = this;
		},
		methods: {

		}
	};
</script>
<style lang='scss'>
	.reading-rules-editor {

	}
</style>
